import Swiper from "swiper/bundle";
import { Navigation, Pagination, Autoplay, Grid } from "swiper/modules";
import 'swiper/scss';

export default class Carousel {
    constructor() {
        this.initCarousel();
    }

    initCarousel() {
        var container = document.querySelector('.banner .swiper');
        const homeBannerSwiper = new Swiper(container, {
            modules: [Navigation, Pagination, Autoplay, Grid],
            direction: 'horizontal',
            slidesPerView: 1,
            loop: true,
            spaceBetween: 0,
            speed: 1000,
            lazyLoading: true,
            keyboard: {
                enabled: false
            },
            navigation: {
                nextEl: '#homeBannerNext',
                prevEl: '#homeBannerPrev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: true
            },
            centeredSlides: true,
            autoHeight: true,            
            //slidesOffsetAfter: 1110,            
        });
    }
}

